import React from "react";
import { Grid, Divider } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputReactDatepicker,
  InputTextMaster,
} from "App/Component/ui";
import { TYPE_INSTANCE3, valueTipePembayaran } from "App/constants";
import { useInitialMasterSupplier, useSelectOption } from "App/hooks";
import { RESET_STATE_FORM_FILTER } from "./helpers";
import { isNull } from "App/utils/helpers";
import { LIST_URL_MASTER } from "utils/masters";

export default function FormFilterDaftarPembayaran({
  formFilter,
  setFormFilter,
  setNewData,
  typeButton = "submit",
}) {
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const kasBank = useSelectOption(
    true,
    LIST_URL_MASTER.kas.list,
    TYPE_INSTANCE3,
    "id",
    "nama"
  );

  const supplier = useInitialMasterSupplier(
    true,
    "/wmsMasterAsset/master/list-supplier"
  );

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
      <Grid container spacing={3}>
          <Grid item sm={3}>
            <InputTextMaster
              name="id"
              type="number"
              label="ID PEMBAYARAN"
              id="id"
              value={formFilter.id}
              onChange={handleChange("id")}
              placeholder="ID Pembayaran"
            />
          </Grid>

          <Grid item sm={3}>
            <InputTextMaster
              name="id_pembelian"
              type="number"
              label="ID PEMBELIAN"
              id="id_pembelian"
              value={formFilter.id_pembelian}
              onChange={handleChange("id_pembelian")}
              placeholder="ID Pembelian"
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name="supplier_id"
              label="SUPPLIER"
              id="supplier_id"
              withSearch={true}
              data={supplier}
              value={formFilter.supplier_id}
              labelValue={formFilter.supplier}
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  supplier_id: e?.value,
                  supplier: e?.label,
                })
              }
            />
          </Grid>

          <Grid item sm={3}>
            <InputTextMaster
              name="no_faktur"
              label="NOMOR FAKTUR"
              id="no_faktur"
              value={formFilter.no_faktur}
              onChange={handleChange("no_faktur")}
              placeholder="Nomor Faktur"
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name="tipe_pembayaran_id"
              label="TIPE PEMBAYARAN"
              id="tipe_pembayaran_id"
              withSearch={false}
              value={formFilter.tipe_pembayaran_id}
              onChange={handleChange("tipe_pembayaran_id")}
              data={valueTipePembayaran}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name="kas_id"
              label="KAS"
              id="kas_id"
              data={kasBank}
              withSearch={true}
              value={formFilter.kas_id}
              labelValue={formFilter.kas_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    kas_id: null,
                    kas_name: "Pilih kas",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    kas_id: e?.value,
                    kas_name: e?.label,
                  });
                }
              }}
            />
          </Grid>

          <Grid item sm={3}>
            {/* <InputTextMaster
              name='tanggal_awal'
              label='TANGGAL AWAL'
              id='tanggal_awal'
              type='date'
              value={formFilter.tanggal_awal}
              onChange={handleChange("tanggal_awal")}
              placeholder='Tanggal Awal'
            /> */}

            <InputReactDatepicker
              selected={formFilter.tanggal_awal}
              label="TANGGAL AWAL"
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tanggal_awal: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tanggal_awal: e,
                })
              }
            />
          </Grid>
          <Grid item sm={3}>
            {/* <InputTextMaster
              name='tanggal_akhir'
              label='TANGGAL AKHIR'
              id='tanggal_akhir'
              type='date'
              value={formFilter.tanggal_akhir}
              onChange={handleChange("tanggal_akhir")}
              placeholder='Tanggal Akhir'
            /> */}

            <InputReactDatepicker
              selected={formFilter.tanggal_akhir}
              label="TANGGAL AKHIR"
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tanggal_akhir: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tanggal_akhir: e,
                })
              }
            />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <MasterButton
            name={"CARI"}
            outline={true}
            color={"green"}
            onClick={handleSubmit}
            type={typeButton}
            size={"md"}
          />
        </Grid>
        <br />
      </form>
      <Divider />
    </>
  );
}
